var map = {
	"./basic.vue": "yXbG",
	"./default.vue": "lfHO",
	"./detail.vue": "Gq4W",
	"./login.vue": "8Ojl",
	"./quiz.vue": "Qt54"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z5yN";


//////////////////
// WEBPACK FOOTER
// ./src/layouts nonrecursive .*\.vue$
// module id = Z5yN
// module chunks = 12